import React from 'react';
import { IPriceValueTranslationData, SaleLabel } from '@secretescapes/cauldron';
import {
  BadgeType,
  Icon,
  IconName,
  IconScale,
  TooltipPosition,
  Typography,
  TypographyVariant,
  useTheme,
} from '@secretescapes/falcon';
import { i18n } from '@secretescapes/i18n';
import { useApplicationState } from '@utils/useApplicationState';
import { useTranslations } from '@utils/useTranslations';
import { TabContainer, TabContent, TabHeaderContainer, TabPriceValue } from './Tab.styles';

interface TabProps {
  isSelected: boolean;
  showAtolProtected: boolean;
  title: string;
  onClick: () => void;
  priceValueInfo: PriceValueInfo;
  translationData: IPriceValueTranslationData;
  iconName: IconName;
  borderRadiusPosition?: 'left' | 'right';
}

export interface PriceValueInfo {
  leadRate: string;
  rackRate: string;
  showRackRate: boolean;
}

export const Tab = ({
  isSelected,
  onClick,
  title,
  showAtolProtected,
  priceValueInfo,
  translationData,
  iconName,
  borderRadiusPosition,
}: TabProps) => {
  const theme = useTheme();
  const { isMobile } = useApplicationState();
  const { translations } = useTranslations();
  const { leadRate, rackRate, showRackRate } = priceValueInfo;

  return (
    <TabContainer
      role="button"
      onClick={onClick}
      isMobile={isMobile}
      isSelected={isSelected}
      borderRadiusPosition={borderRadiusPosition}
    >
      <TabHeaderContainer>
        <Icon name={iconName} size={IconScale.m} />
        <Typography variant={TypographyVariant.body}>{title}</Typography>
      </TabHeaderContainer>
      <TabContent>
        <TabPriceValue
          leadRate={leadRate}
          showRackRate={showRackRate}
          rackRate={rackRate}
          showTooltip={!!translationData.leadRateTooltip}
          tooltipPosition={TooltipPosition.bottom}
          translationData={translationData}
        />

        {showAtolProtected && (
          <SaleLabel
            saleLabelTranslations={{
              translatedLabelValue: i18n('flights.atol.protected', [], translations),
            }}
            backgroundColor={theme.color.success05}
            fontColor={theme.color.success70}
            type={BadgeType.INFORMATIONAL}
            priority={1}
          />
        )}
      </TabContent>
    </TabContainer>
  );
};
